module.exports = __webpack_public_path__ + "static/media/escudo_icon.68443645.svg";